export default __webpack_public_path__ + "static/media/black_pawn.6af5dd63.png";